module.exports = __webpack_public_path__ + "static/img/img06-03.14aaf26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c37/img06-03.png
// module id = +h0F
// module chunks = 0